export default "__VITE_ASSET__iHWTJMf$__"